<template>
  <view-toolbox
    back-title="Edit Login"
    title="Design"
  >
    <div>
      <label for="title">
        Title
      </label>
      <input
        v-model="viewRaw.title"
        type="text"
        name="title"
      >
    </div>
    <div>
      <label for="title">
        Description
      </label>
      <textarea
        v-model="viewRaw.description"
        name="description"
      />
    </div>
  </view-toolbox>
</template>

<script>
import ViewToolbox from '@/components/views/ViewToolbox';
import ViewUtils from '@/components/views/ViewUtils';
import DesignUtils from '@/components/views/DesignUtils';
import ChoicePicker from '@/components/ui/inputs/ChoicePicker';
import ColorPicker from '@/components/ui/inputs/ColorPicker';

export default {
  name: 'LoginSettings',
  components: {
    ViewToolbox,
    ChoicePicker,
    ColorPicker,
  },
  mixins: [
    ViewUtils,
    DesignUtils,
  ],
};
</script>
